import React from "react";
import { useTranslation } from "react-i18next";

interface BookingResponse {
  id: number;
  email: string | null;
  bookingDetailId: number;
  status: string;
  productId: number;
  qtyAdult: number;
  qtyChild: number;
  qtyRoom: number;
  qtySim: number | null;
  qtyVehicle: number | null;
  ageNumbers: string;
  selectDateNow: boolean;
  duration: number;
  totalPaid: number;
  updatedAt: string;
  priceTotalVehicle: number | null;
  priceTotalAdult: number;
  priceTotalChild: number;
  priceTotalRoom: number | null;
  priceTotalItem: number;
  booking: {
    status: string;
    id: number;
    bookNo: number;
    bookTime: string;
    price: number;
    priority1: string | null;
    priority2: string | null;
    priority3: string | null;
    product: {
      id: number;
      cityName: string | null;
      name: string;
      thumbnail: string;
      productType: string;
      categoryId: number | null;
      categories: {
        id: number;
        name: string;
      };
      howToUse: string;
      information: string;
      noteContent: string;
      originalPrice: number | null;
      price: number | null;
      categoryName: string | null;
      duration: number;
      discount: {
        value: number;
        discountType: string;
      };
      showHome: boolean;
    };
    statusTime: string | null;
  };
  request: any | null;
  additional: any | null;
  luggage: any | null;
  pickUpAirport: any | null;
  priorities: any | null;
  ticketType: any | null;
  seat: any | null;
  dataPackage: any | null;
  simValidity: any | null;
  dropOffLocation: any | null;
  productInfo: {
    id: number;
    name: string;
    thumbnail: string;
    cityName: string;
    selectDate: string | null;
    priceList: Array<{ typePrice: string; price: number }> | null;
    attributeList: Array<{ id: number; type: string; value: string }>;
    discount: {
      value: number;
      adultValue: number | null;
      childValue: number | null;
      discountType: string;
    };
    productType: string;
    priceSimResponse: any | null;
    refund: boolean;
    edit: boolean;
  };
  products: BookingResponse[];
  bookingConfirm: any | null;
}

interface OrderDTO {
  orderDate: string;
  paymentStatus: string | null;
  orderStatus: string;
  subCategory: string;
  userName: string | null;
  phone: string;
  emailCustomer: string;
  emailUser: string | null;
  discountValue: number;
  totalPrice: number;
  address: string;
  nameCustomer: string;
  requirement: string | null;
  statusTime: string | null;
  bookingResponse: BookingResponse;
}

interface BookingDetailsProps {
  bookingData: OrderDTO;
}

const BookingDetails: React.FC<BookingDetailsProps> = ({ bookingData }) => {
  const { t } = useTranslation();
  return (
    <div className="rounded-[1.25rem] border border-[#DCDCDC] p-[1.25rem] pr-[6.25rem] pt-[1.3125rem]">
      <div className="flex flex-col gap-[0.9375rem]">
        <p className="text-base font-semibold">
          {t("Product ")}({t("Total ")}
          {bookingData?.bookingResponse.products?.length} {t("choices")})
        </p>

        {/* Observation */}
        <div className="flex justify-start">
          <p className="w-[22rem] text-[0.875rem] font-semibold">
            {t("Observation")}
          </p>
          <div className="w-[29.5625rem] text-[0.875rem]">
            {bookingData?.bookingResponse.products
              ?.filter((product) =>
                ["SIM", "TICKET", "TOUR"].includes(
                  product.productInfo.productType,
                ),
              )
              .map((product) => (
                <p className="font-normal text-[#232323]">
                  • {product.productInfo.name}
                </p>
              ))}
          </div>
        </div>

        {/* Duration */}
        {/* <div className="flex justify-start">
          <p className="font-semibold w-[22rem] text-[0.875rem]"></p>
          <div className="w-[29.5625rem] text-[0.875rem]">
            <p className="font-normal text-[#232323]"> days</p>
          </div>
        </div> */}

        {/* Art gallery, Museum */}

        <div className="flex justify-start">
          <p className="w-[22rem] text-[0.875rem] font-semibold">
            {t("Art gallery, Museum")}
          </p>
          <div className="w-[29.5625rem] text-[0.875rem]">
            <p className="font-normal text-[#232323]">
              {bookingData?.bookingResponse.products
                ?.filter((product) =>
                  ["MUSICAL"].includes(product.productInfo.productType),
                )
                .map((product) => (
                  <p className="font-normal text-[#232323]">
                    • {product.productInfo.name}
                  </p>
                ))}
            </p>
          </div>
        </div>

        {/* Room */}
        {/* <div className="flex justify-start">
          <p className="font-semibold w-[22rem] text-[0.875rem]">Room</p>
          <div className="w-[29.5625rem] text-[0.875rem]">
            <p className="font-normal text-[#232323]"></p>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default BookingDetails;
